import {
  PREORDER_EVENTS_LOADING,
  PREORDER_EVENTS_FAIL,
  PREORDER_EVENTS_LIST,
  PREORDER_EVENTS_REGISTER,
  PREORDER_EVENTS_REFRESH,
  PREORDER_EVENTS_SET_FILTER,
  PREORDER_EVENT_DETAILS_SUCCESS,
  PREORDER_EVENT_ARCHIVE_SUCCESS,
  PREORDER_EVENT_UPDATE_SUCCESS,
  PREORDER_ITEM_ADD_SUCCESS,
  PREORDER_EVENT_ORDERS_LOADING,
  PREORDER_EVENT_ORDERS_SUCCESS,
  PREORDER_EVENT_ORDERS_FAIL,
  PREORDER_ORDER_UPDATE_LOADING,
  PREORDER_ORDER_UPDATE_SUCCESS,
  PREORDER_ORDER_UPDATE_FAIL,
  PREORDER_ITEMS_BULK_PUBLISH_LOADING,
  PREORDER_ITEMS_BULK_PUBLISH_SUCCESS,
  PREORDER_ITEMS_BULK_PUBLISH_FAIL,
  PreorderEventsDispatchTypes,
  PreorderEventList,
  PreorderEventFilters,
  PreorderEventDetails,
  PreorderEventOrdersList,
  PreorderRecommendedCloseDistributionResponse,
  PREORDER_EVENT_SUGGESTED_SUCCESS,
  PREORDER_EVENT_SUGGESTED_CLEAR
} from "../actions/preorderEventActions/PreorderEventActionsTypes";

// Default state interface.
interface DefaultStateI {
  loading: string;
  preorderEventList?: PreorderEventList;
  preorderEventDetails?: PreorderEventDetails;
  refresh?: boolean;
  preorderEventFilters?: PreorderEventFilters;
  preorderEventOrders?: PreorderEventOrdersList;
  actionStatus?: any;
  suggestedPreorderCloseDistribution: PreorderRecommendedCloseDistributionResponse | undefined;
}

// Default state.
const defaultState: DefaultStateI = {
  loading: "",
  preorderEventList: undefined,
  preorderEventDetails: undefined,
  refresh: false,
  preorderEventFilters: {},
  preorderEventOrders: undefined,
  actionStatus: undefined,
  suggestedPreorderCloseDistribution: undefined
};

const PreorderEventReducer = (
  state: DefaultStateI = defaultState,
  action: PreorderEventsDispatchTypes
): DefaultStateI => {
  switch (action.type) {
    case PREORDER_EVENTS_FAIL:
      return {
        ...state,
        loading: "",
        actionStatus: { menssage: action.payload, status: "error" }
      };
    case PREORDER_EVENTS_LOADING:
      return {
        ...state,
        loading: action.payload
      };
    case PREORDER_EVENTS_REGISTER:
      return {
        ...state,
        loading: "",
        actionStatus: { menssage: action.payload, status: "success" }
      };
    case PREORDER_EVENTS_LIST:
      return {
        ...state,
        loading: "",
        actionStatus: undefined,
        preorderEventList: action.payload
      };
    case PREORDER_EVENTS_REFRESH:
      return {
        ...state,
        refresh: action.payload
      };
    case PREORDER_EVENTS_SET_FILTER:
      return {
        ...state,
        preorderEventFilters: action.payload
      };
    case PREORDER_EVENT_ORDERS_LOADING:
      return {
        ...state,
        loading: action.payload
      };
    case PREORDER_EVENT_ORDERS_SUCCESS:
      return {
        ...state,
        loading: "",
        preorderEventOrders: action.payload
      };
    case PREORDER_EVENT_ORDERS_FAIL:
      return {
        ...state,
        loading: "",
        actionStatus: { menssage: action.payload, status: "error" }
      };
    case PREORDER_EVENT_DETAILS_SUCCESS:
      return {
        ...state,
        loading: "",
        actionStatus: undefined,
        preorderEventDetails: action.payload
      };
    case PREORDER_EVENT_ARCHIVE_SUCCESS:
      return {
        ...state,
        loading: "",
        actionStatus: { menssage: action.payload, status: "success" }
      };
    case PREORDER_EVENT_UPDATE_SUCCESS:
      return {
        ...state,
        loading: "",
        actionStatus: { menssage: action.payload, status: "success" }
      };
    case PREORDER_ITEM_ADD_SUCCESS:
      return {
        ...state,
        loading: "",
        actionStatus: { menssage: action.payload, status: "success" }
      };
    case PREORDER_ORDER_UPDATE_LOADING:
      return {
        ...state,
        loading: action.payload,
        actionStatus: undefined
      };
    case PREORDER_ORDER_UPDATE_SUCCESS:
      return {
        ...state,
        loading: "",
        actionStatus: { menssage: action.payload, status: "success" }
      };
    case PREORDER_ORDER_UPDATE_FAIL:
      return {
        ...state,
        loading: "",
        actionStatus: { menssage: action.payload, status: "error" }
      };
    case PREORDER_EVENT_SUGGESTED_SUCCESS:
      return {
        ...state,
        loading: "",
        actionStatus: { menssage: action.payload, status: "success" },
        suggestedPreorderCloseDistribution: action.payload
      };
    case PREORDER_EVENT_SUGGESTED_CLEAR:
      return {
        ...state,
        suggestedPreorderCloseDistribution: undefined
      };
    case PREORDER_ITEMS_BULK_PUBLISH_LOADING:
      return {
        ...state,
        loading: action.payload
      };
    case PREORDER_ITEMS_BULK_PUBLISH_SUCCESS:
      return {
        ...state,
        loading: "",
        actionStatus: { menssage: action.payload, status: "success" }
      };
    case PREORDER_ITEMS_BULK_PUBLISH_FAIL:
      return {
        ...state,
        loading: "",
        actionStatus: { menssage: action.payload, status: "error" }
      };
    default:
      return state;
  }
};

export default PreorderEventReducer;